import { t } from "i18next"

export const BusinessType = [
  { value: "town", label: t("Ikata town") },
  { value: "hotSpring", label: t("Hot spring") },
  { value: "sportsCenter", label: t("Sports center") },
  { value: "bus", label: t("Loop bus") },
]
